import { AffiliateAccountStatusResponse } from "@syla/shared/types/responses/AffiliateAccountStatusResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function getAffiliateAccountStatus(): Promise<AffiliateAccountStatusResponse> {
  try {
    const response = await axios.get<AffiliateAccountStatusResponse>(
      "/users/affiliate-account-status",
    );
    return response.data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
